import api from '@/api';
import { PageResult } from '@/core/request/PageResult';

import { API_BASE_URL } from '..';
import {
  Mail,
  MailListRequestParams,
  MailSendingRequestParams,
  PurchaseMailSendingRequestParams,
} from './MailControler.types';

const CONTROLLER_URL = `${API_BASE_URL}`;

export async function mailWorkorderList(params: MailListRequestParams) {
  const result = (await api.get(
    `${CONTROLLER_URL}/mail/workorder/${params.workorderId}`,
    params,
  )) as unknown;

  return result as PageResult<Mail>;
}

export async function mailSending(data: MailSendingRequestParams) {
  const result = (await api.post(`${CONTROLLER_URL}/sending`, data)) as unknown;

  return result as Mail;
}

export async function sendMail(data: PurchaseMailSendingRequestParams) {
  const result = (await api.post(`${CONTROLLER_URL}/mail`, data)) as unknown;

  return result as Mail;
}
